module.exports = __webpack_public_path__ + "static/media/zera_putting_circle.5d62db00.png";